import CheryMotorH from '@/assets/image/home/CheryMotorH.png'
import CheryMotorD from '@/assets/image/home/CheryMotorD.png'
import couponH from '@/assets/image/home/couponH.png'
import couponD from '@/assets/image/home/couponD.png'
import activityH from '@/assets/image/home/activityH.png'
import activityD from '@/assets/image/home/activityD.png'
import channelH from '@/assets/image/home/channelH.png'
import channelD from '@/assets/image/home/channelD.png'
import cmsH from '@/assets/image/home/cmsH.png'
import cmsD from '@/assets/image/home/cmsD.png'
import BIH from '@/assets/image/home/BIH.png'
import BID from '@/assets/image/home/BID.png'

import cultivationH from '@/assets/image/home/cultivationH.png'
import cultivationD from '@/assets/image/home/cultivationD.png'
import userH from '@/assets/image/home/userH.png'
import userD from '@/assets/image/home/userD.png'
import dealercardwebH from '@/assets/image/home/dealercardwebH.png'
import dealercardwebD from '@/assets/image/home/dealercardwebD.png'
import WxH from '@/assets/image/home/WxH.png'
import WxD from '@/assets/image/home/WxD.png'

import Yeepay from '@/assets/image/home/Yeepay.png'

import noMessage from '@/assets/image/home/backlog1.png'
import noJob from '@/assets/image/home/backlog2.png'

import logoImg from '@/assets/image/home/logoImg.png'

import agenda from '@/assets/image/home/agenda.png'
import ask from '@/assets/image/home/ask.png'
import message from '@/assets/image/home/message.png'

export default {
  CheryMotorH,
  CheryMotorD,
  couponH,
  couponD,
  activityH,
  activityD,
  channelH,
  channelD,
  cmsH,
  cmsD,
  BIH,
  BID,
  cultivationH,
  cultivationD,
  userH,
  userD,
  dealercardwebH,
  dealercardwebD,
  WxD,
  WxH,
  Yeepay,
  noMessage,
  noJob,
  logoImg,
  agenda,
  ask,
  message
}



// WEBPACK FOOTER //
// ./src/lib/imgUrl.js